import React, { useContext, useEffect, useState } from 'react'
import MsgUtils from '../Tools/MsgUtils';
import Modal from 'react-bootstrap/Modal';
import UtilsBufer from '../Tools/UtilsBufer';
import GenPregunta from './GenPregunta';
import { contextFormulario } from './PrincipalFormulario';
const server = process.env.REACT_APP_SERVER;
function ContenidoFormulario(props) {
    const { selectItem, setVentana, regional, soloVer,
        setLoader, selectRespuesta, setSelectRespuesta, setVerRespuesta } = props;
    const [preguntas, setPreguntas] = useState([]);
    const [actualizar, setActualizar] = useState(false);
    const [itemSelect, setItemSelect] = useState({});
    const [deleteSelect, setDeleteSelect] = useState({});
    const [modalShow, setModalShow] = useState(false);
    function actualizarVista() {
        setActualizar(!actualizar);
        setModalShow(false);
    }
    function editarPregunta(valor) {
        setItemSelect(valor);
        setModalShow(true);
    }
    function eliminarPregunta() {
        fetch(`${server}/formulario/deletePregunta`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                regional, ...deleteSelect
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.ok) {
                    MsgUtils.msgCorrecto(data.ok);
                    setDeleteSelect({});
                    setActualizar(!actualizar);
                } else {
                    MsgUtils.msgError(data.error);
                }
            })
            .catch(err => MsgUtils.msgError(err));
    }
    function salirDeContenido() {
        if (selectRespuesta === null) {
            setVentana(0);
        } else {
            setSelectRespuesta(null);
            setVerRespuesta(false);
            setVentana(2);
        }
    }
    function getRespuestaUsuario(dato) {
        if (selectRespuesta == null) {
            return ''
        } else {
            var resultado = selectRespuesta.RESPUESTA.filter((item) => item.ID_PREGUNTA === dato.ID_PREGUNTA);
            if (resultado.length !== 0) {
                if (resultado[0].ID_OPCION !== 0) {
                    if (resultado[0].ID_OPCION === dato.ID_OPCION) {
                        return resultado[0].ID_OPCION;
                    } else {
                        return ''
                    }
                } else {
                    if (dato.TIPO === 'R') {
                        return UtilsBufer.getText(resultado[0].DESCRIPCION)
                    } else if (dato.TIPO === 'F') {
                        return UtilsBufer.getText(resultado[0].DESCRIPCION)
                    }
                }
            } else {
                return ''
            }
        }
    }
    function getRespuestaMultipleUsuario(dato, tipo) {
        if (selectRespuesta == null) {
            return ''
        } else {
            var resultado = selectRespuesta.RESPUESTA.filter((item) => item.ID_PREGUNTA === dato.ID_PREGUNTA && item.ID_OPCION === dato.ID_OPCION);
            if (resultado.length !== 0) {
                if(['S','M'].includes(tipo)==true){
                    return resultado[0].ID_OPCION;
                }else if(tipo=='O'){
                    return UtilsBufer.getText(resultado[0].DESCRIPCION)
                }
            } else {
                return ''
            }
        }
    }
    useEffect(() => {
        setLoader(true);
        fetch(`${server}/formulario/getPreguntas`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                regional, "ID_ENCUESTA": selectItem.ID_ENCUESTA
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.ok) {
                    setPreguntas(data.ok);
                } else {
                    MsgUtils.msgError(data.error);
                }
                setLoader(false);
            })
            .catch(err => MsgUtils.msgError(err));
    }, [actualizar])
    return (
        <>
            <div className='container-fluid text-light bg-dark'>
                <div className='row row-cols-2 g-0'>
                    {selectRespuesta === null &&
                        <div className='col-10 my-auto'>
                            TITULO : {selectItem.TITULO}
                        </div>}
                    {selectRespuesta !== null && <div className='col-10 my-auto'>
                        <div className='text-center fs-5'>TITULO : {selectItem.TITULO}</div>
                        <div className="card bg-transparent flex-row m-0 p-0" style={{ border: 'none' }}>
                            {UtilsBufer.getFotoCard(selectRespuesta.FOTO, 40)}
                            <div className='ps-2 my-auto d-none d-sm-inline'>
                                <div className="cargoHeader fw-bold" id="nameBuscar">{selectRespuesta.NOMBREX}</div>
                                <div className='cargoHeader '>{selectRespuesta.CARGO}</div>
                            </div>
                        </div>
                    </div>}
                    <div className='col-2 text-end my-auto'>
                        <button className='btn btn-sm text-danger' onClick={() => salirDeContenido()}>
                            <i className="fa-solid fa-circle-xmark fa-2xl"></i>
                        </button>
                    </div>
                </div>
            </div>
            {soloVer === false && <div className='container-fluid py-1'>
                <button className='btn btn-sm btn-success bg-gradient w-100'
                    onClick={() => { setItemSelect({}); setModalShow(true) }}
                ><i className="fa-solid fa-circle-plus fa-xl"></i> Crear Nueva Pregunta</button>
            </div>}
            <div className='container-fluid'>
                {preguntas.map((item, index) => {
                    return (
                        <div className='card m-2' key={index}>
                            <div className='card-header m-0 p-0 mx-2'>
                                {`Pregunta: ${index + 1}`}
                            </div>
                            <div className='card-body m-1 fw-bold fs-5'>
                                {`${UtilsBufer.getText(item.DESCRIPCION)}`}
                            </div>
                            {item.NOMBRE && <img src={`${server}/imagenes/${item.NOMBRE}`} className="card-img-top w-25 mx-auto"></img>}
                            <div className='card-body'>
                                {item.TIPO === 'R' &&
                                    <input type="text" className="form-control form-control-sm" disabled={true}
                                        placeholder="Responde aqui ..." value={getRespuestaUsuario(item)} />
                                }
                                {item.TIPO === 'S' &&
                                    <div className=''>
                                        {item.OPCIONES.map((item, index) => {
                                            return (
                                                <div className="form-check py-2" key={index}>
                                                    <input className="form-check-input " type='radio' disabled={true}
                                                        defaultChecked={getRespuestaUsuario(item) !== '' ? true : false} />
                                                    {item.NOMBRE &&
                                                        <div className='position-relative' style={{ width: "70px" }}>
                                                            <img src={`${server}/imagenes/${item.NOMBRE}`} className="img-fluid">
                                                            </img>
                                                        </div>}
                                                    <label className="form-check-label" >
                                                        {UtilsBufer.getText(item.DESCRIPCION)}
                                                    </label>
                                                </div>
                                            )
                                        })}
                                    </div>}
                                {item.TIPO === 'M' &&
                                    <div className=''>
                                        {item.OPCIONES.map((inf, index) => {
                                            return (
                                                <div className="form-check py-2" key={index}>
                                                    <input className="form-check-input " type={`${inf.TIPO === 'S' ? 'radio' : 'checkbox'}`} disabled={true}
                                                        defaultChecked={getRespuestaMultipleUsuario(inf, item.TIPO) !== '' ? true : false} />
                                                    {inf.NOMBRE &&
                                                        <div className='position-relative' style={{ width: "70px" }}>
                                                            <img src={`${server}/imagenes/${inf.NOMBRE}`} className="img-fluid">
                                                            </img>
                                                        </div>}
                                                    <label className="form-check-label" >
                                                        {UtilsBufer.getText(inf.DESCRIPCION)}
                                                    </label>
                                                </div>
                                            )
                                        })}
                                    </div>}
                                {item.TIPO === 'O' &&
                                    <div className='container-fluid'>
                                        {item.OPCIONES.map((opti, index) => {
                                            return (
                                                <div className='row row-cols g-1'>
                                                    {opti.NOMBRE && 
                                                    <div className='col' style={{ width: "70px" }}>
                                                        <div className='position-relative' style={{ width: "70px" }}>
                                                            <img src={`${server}/imagenes/${opti.NOMBRE}`} className="img-fluid">
                                                            </img>
                                                        </div>
                                                    </div>}
                                                    <div className='col'>
                                                        <div className="input-group mb-1 input-group-sm" key={index}>
                                                            <label className="input-group-text">{UtilsBufer.getText(opti.DESCRIPCION)}</label>
                                                            <input className="form-control" type="text" placeholder='Responde aqui' disabled 
                                                            value={getRespuestaMultipleUsuario(opti,item.TIPO)}/>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })}
                                    </div>}
                                {item.TIPO === 'F' &&
                                    <div className='container-fluid'>
                                        <span>Fecha: </span>
                                        <input type="date" className="form-control form-control-sm" style={{ width: '200px' }} disabled={true}
                                            value={getRespuestaUsuario(item)} />
                                    </div>}
                                {item.TIPO === 'H' &&
                                    <div className='container-fluid'>
                                        <span>Hora: </span>
                                        <input type="time" className="form-control form-control-sm" style={{ width: '200px' }} />
                                    </div>}
                            </div>
                            {soloVer === false && <div className='card-footer text-end'>
                                <button className='btn btn-danger btn-sm' onClick={() => setDeleteSelect(item)}
                                    data-bs-toggle="modal" data-bs-target="#EliminarModal">
                                    <i className="fa-solid fa-trash-can fa-xl"></i> Eliminar
                                </button>
                                <button className='btn btn-warning btn-sm'
                                    onClick={() => editarPregunta(item)}>
                                    <i className="fa-solid fa-pen-to-square fa-xl"></i> Editar
                                </button>
                            </div>}
                        </div>
                    )
                })}
            </div>
            <div className="modal fade" id="EliminarModal" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content bg-warning">
                        <div className="modal-header m-0 p-0 mx-2">
                            <h5 className="modal-title" id="exampleModalLabel">Eliminar Pregunta</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <div className='text-dark fs-1'>
                                <i className="fa-solid fa-triangle-exclamation fa-fade"></i> Esta seguro de Eliminar!!!
                            </div>
                        </div>
                        <div className="modal-footer m-0 p-0 mx-2">
                            <button type="button" className="btn btn-sm btn-secondary"
                                data-bs-dismiss="modal"><i className="fa-solid fa-thumbs-down"></i> NO</button>
                            <button type="button" className="btn btn-sm btn-primary"
                                data-bs-dismiss="modal" onClick={() => eliminarPregunta()}>
                                <i className="fa-solid fa-thumbs-up"></i> SI
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <Modal show={modalShow} onHide={() => setModalShow(false)}
                size="xl"
                aria-labelledby="contained-modal-title-vcenter"
                contentClassName='bg-dark bg-gradient'>
                <Modal.Header closeButton closeVariant='white' bsPrefix='modal-header m-0 p-0 px-2'>
                    <Modal.Title>
                        <div className='text-light'>{itemSelect.ID_PREGUNTA !== undefined ? 'Editar Pregunta' : 'Nueva Pregunta'}</div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body bsPrefix='modal-body m-0 p-0'>
                    <GenPregunta refresh={actualizarVista} preguntas={preguntas} itemSelect={itemSelect} />
                </Modal.Body>
            </Modal>
        </>
    )
}

export default ContenidoFormulario
